<template>
  <vue-winwheel :segments="options" />
</template>

<script>
import VueWinwheel from 'vue-winwheel/vue-winwheel'
export default {
  components: {
    VueWinwheel,
  },
  data() {
    return {
      options: [
        {
          textFillStyle: "#fff",
          fillStyle: "#6482FF",
          text: "Prize 1",
        },
        {
          textFillStyle: "#6482FF",
          fillStyle: "#fadede",
          text: "Prize 2",
        },
        {
          textFillStyle: "#fff",
          fillStyle: "#6482FF",
          text: "Prize 3",
        },
        {
          textFillStyle: "#6482FF",
          fillStyle: "#fadede",
          text: "Prize 4",
        },
        {
          textFillStyle: "#fff",
          fillStyle: "#6482FF",
          text: "Prize 5",
        },
        {
          textFillStyle: "#6482FF",
          fillStyle: "#fadede",
          text: "Prize 6",
        },
        {
          textFillStyle: "#fff",
          fillStyle: "#6482FF",
          text: "Prize 7",
        },
        {
          textFillStyle: "#6482FF",
          fillStyle: "#fadede",
          text: "Prize 8",
        },
        
      ],
    };
  },
};
</script>

<style>
</style>